import { PropsWithChildren } from 'react';

import { Box, Typography } from '@mui/material';
import pluralizeFn from 'pluralize';

import { tokens } from '../../../../theme/generated/tokens';
import { SxProps } from '../../../../types';

export type TableRecordsCountProps = PropsWithChildren<{
  title?: string;
  count?: number;
  outOf?: number;
  postfix?: string;
  visible?: boolean;
  pluralize?: boolean;
  sx?: SxProps;
  showZero?: boolean;
}>;

export const TableRecordsCount = ({
  count,
  outOf,
  title = 'entry',
  postfix,
  pluralize = true,
  showZero = false,
  sx,
  children,
}: TableRecordsCountProps) => {
  const renderCount = () => {
    if (count === 0) {
      return showZero ? '0/' : undefined;
    }

    if (!count) {
      return undefined;
    }
    if (outOf === undefined) {
      return count;
    }
    return `${count}/`;
  };

  return (
    <Box className="RecordsCount-root" mr={8} sx={sx}>
      <Typography
        variant="A1"
        sx={{ color: tokens.theme.fg.structural.secondary }}
        data-testid="records-count"
      >
        {children ?? (
          <>
            {/* Span elements necessary for browser translators not to break UI when parts of message get replaced */}
            <span>{renderCount()}</span>
            <span>{outOf}</span>
            <span>
              {` ${pluralize ? pluralizeFn(title, outOf ?? 0) : title}`}
            </span>
            {postfix ? <span>{` ${postfix}`}</span> : null}
          </>
        )}
      </Typography>
    </Box>
  );
};
